import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';

interface ContactInfoProps {
  email: string;
  phone: string;
  address: string;
}

export const ContactInfo: React.FC<ContactInfoProps> = ({ email, phone, address }) => {
  return (
    <div className="bg-blue-600 text-white p-8 rounded-lg">
      <h3 className="text-2xl font-bold mb-6">Informations de contact</h3>
      <div className="space-y-6">
        <div className="flex items-start">
          <Mail className="h-6 w-6 mr-4 mt-1" />
          <div>
            <h4 className="font-semibold">Email</h4>
            <p className="text-blue-100">{email}</p>
          </div>
        </div>
        <div className="flex items-start">
          <Phone className="h-6 w-6 mr-4 mt-1" />
          <div>
            <h4 className="font-semibold">Téléphone</h4>
            <p className="text-blue-100">{phone}</p>
          </div>
        </div>
        <div className="flex items-start">
          <MapPin className="h-6 w-6 mr-4 mt-1" />
          <div>
            <h4 className="font-semibold">Adresse</h4>
            <p className="text-blue-100">2 rue des 4 églises, 54000 Nancy</p>
          </div>
        </div>
      </div>
    </div>
  );
};